<template>
	<div class="control">
		<div class="form-group">
			<select :title="parent.placeholder" :id="'form-' + parent.specification" class="form-control selectpicker" @change="updateFilters(checkbox, $event)" v-model="selectedValues" multiple>
				<option v-bind:value="checkbox.value" v-for="(checkbox, index) in checkboxes">
					{{ checkbox.label }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['controls', 'parent', 'specification'],
		data: function () {
			return {
				checkboxes: this.controls,
				checkbox: "", 
                selectedValues: []
			}
		},
		watch: {
			parent: {
				handler(newVal) {
					// remove logic if selecting parent should not select children
					//if (newVal.selected === true) {
					//	this.selectedValues = [];

					//	for (let check of this.checkboxes) {
					//		this.selectedValues.push(check.value);
					//		check.selected = true;
					//	}
					//}
				},
				deep: true,
			}
		},
		beforeCreate: function () {
			this.$options.components.CheckboxControl = require('./checkbox-control.vue').default;
		},
		mounted: function () {
			let initialData = this.$store.state.listing.specification[this.parent.specification];
			if (initialData != null && initialData !== '') {
				this.selectedValues = initialData;
			}
			// clear current input on reset
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/resetSpecification') {
					this.selectedValues = [];
				}
			});
		},
		methods: {
			updateFilters(checkbox, $event) {
				this.$emit('updatecheckboxfilter');

				// if auto selecting all child checkboxes on parent select
				//if ($event.target.checked) {
				//	checkbox.selected = true;
				//}
				//else {
				//	checkbox.selected = false;
				//}
			},
			updateCheckboxFilter() {
				this.$emit('updatecheckboxfilter');
			}
		}
	}
</script>